import React from 'react';
import { GradientStop } from '@capture/gradient-core'
import { ColorSwatch, ColorSwatchRep } from '@capture/color-core';
import {GradientWorker} from '@capture/gradient-core';
let _gradientWorker;

export default class GradientCanvas extends React.Component {
    constructor(props) {
        super(props);
        _gradientWorker = new GradientWorker();
        this.gradientStrip = React.createRef();
        this.extractGradient = this.extractGradient.bind(this);
        this._updateGradient = this._updateGradient.bind(this);
        this.state = {
            stops: []
        }
    }

    componentDidMount() {
        this.gradientStripBackgroundRender(this.props.stops)
        if (this.props.imageData != null){
            this.extractGradient(this.props.imageData, this.props.imageData.width, this.props.imageData.height, [], this.props.stopsCount);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.extractGradient(nextProps.imageData, nextProps.imageData.width, nextProps.imageData.height,[], nextProps.stopsCount)
    }

    /*
    inputPath is the path along which gradient has to be found.
    empty array passed to the extractor will return a default gradient along a path stored in message.path
    If you want to find gradient along a custom path, pass an array of x,y coordinates obtained from mousemove event as inputPath arg
    markers array returned as output of gradientExtractor represents array of X,Y coordinates for pucks used to denote
    color pickers shown along a path which creates gradient
     */
    extractGradient(imageData, width, height, inputPath, stopsCount) {
        let message = { imageData, width, height, stopsCount };
        let path = inputPath.slice();
        if (path && path.length > 0) {
            path.forEach((point, index) => {
                path[index] = {
                    x: point.x * (width / this.props.canvasWidth),
                    y: point.y * (height / this.props.canvasHeight)
                };
            });

            message.path = path;
        }
        _gradientWorker.onmessage =  extractedData => {
            const swatches = [];
            const markers = [];
            extractedData.data[0].forEach(stop => {
                markers.push({
                    x: stop.position.x / width,
                    y: stop.position.y / height
                });
                swatches.push({
                    r: stop.color.r,
                    g: stop.color.g,
                    b: stop.color.b
                });
            });
            this._updateGradient(extractedData.data[0]);
        };
        _gradientWorker.postMessage(message);
    }

    _updateGradient(gradientData) {
        const numStops = gradientData.length;
        const gradientStops = gradientData.map((s, index) => new GradientStop(new ColorSwatch(new ColorSwatchRep(s.color)), index / (numStops - 1)));
        this.setState({
            stops: gradientStops
        })
    }

    gradientStripBackgroundRender() {
        const colorStopStrings = [];
        this.state.stops.forEach((gradientStop, index) => {
            const stopColorRGB = gradientStop.color.getRGBRepresentation().value;
            const stopColorPercent = gradientStop.offset * 100;
            colorStopStrings.push(`rgb(${stopColorRGB.r}, ${stopColorRGB.g}, ${stopColorRGB.b}) ${stopColorPercent}%`);
        });
        return `linear-gradient(to right, ${colorStopStrings.join(',')})`;
    }

    render() {
        return(<div
            style={{
                marginLeft:'20%',
                height: 16,
                backgroundImage: this.gradientStripBackgroundRender()
            }}
            ref={this.gradientStrip}
        />)
    }
}